import { Navigate, useLocation } from "react-router-dom";
import { deleteAuth } from "../../utils/security";
import { useSelector } from "react-redux";

const RequireAuth = ({ children }) => {
  const auth = useSelector((state) => state.authManager.value);
  const location = useLocation();

  if (!auth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!auth.user || !auth.checkingDate) {
    deleteAuth();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
